const state = {
  user_data: [],
  group_data: [],
};
export default state;
